import { render, staticRenderFns } from "./ExportsDataList.vue?vue&type=template&id=72a7a57a&"
import script from "./ExportsDataList.vue?vue&type=script&lang=js&"
export * from "./ExportsDataList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports